import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { Menu } from "lucide-react";
import { CartDrawer } from "./CartDrawer";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

const nav = [
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "About" },
  { to: "/journal", label: "Journal" },
  { to: "/care", label: "Care" },
  { to: "/faq", label: "FAQ" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-border/70 bg-background/85 backdrop-blur">
      <div className="container-luxe flex h-16 items-center justify-between gap-4 md:h-20 md:gap-6">
        <div className="flex items-center gap-2 md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger
              aria-label="Open menu"
              className="-ml-2 inline-flex h-10 w-10 items-center justify-center rounded-full text-foreground/80 transition-colors hover:bg-secondary hover:text-foreground"
            >
              <Menu className="h-5 w-5" />
            </SheetTrigger>
            <SheetContent side="left" className="w-[85vw] max-w-sm p-0">
              <SheetHeader className="border-b border-border/70 px-6 py-5 text-left">
                <SheetTitle className="font-display text-xl tracking-tight">
                  European Wig Luxury
                </SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col px-2 py-4">
                {nav.map((n) => (
                  <Link
                    key={n.to}
                    to={n.to}
                    onClick={() => setOpen(false)}
                    className="rounded-md px-4 py-3 font-display text-lg text-foreground/85 transition-colors hover:bg-secondary hover:text-foreground"
                    activeProps={{ className: "text-foreground" }}
                  >
                    {n.label}
                  </Link>
                ))}
                <Link
                  to="/contact"
                  onClick={() => setOpen(false)}
                  className="rounded-md px-4 py-3 font-display text-lg text-foreground/85 transition-colors hover:bg-secondary hover:text-foreground"
                >
                  Contact
                </Link>
              </nav>
            </SheetContent>
          </Sheet>
        </div>

        <Link to="/" className="font-display tracking-tight text-lg sm:text-xl md:text-2xl">
          European Wig Luxury
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className="text-sm text-foreground/80 transition-colors hover:text-foreground"
              activeProps={{ className: "text-foreground" }}
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <CartDrawer />
      </div>
    </header>
  );
}
